import React, { createContext, useContext, useState, useEffect } from 'react';
import { node } from 'prop-types';
import { useLocation } from 'react-router-dom';

const RouteContext = createContext({
  collapseSidebar: false,
  routeConfig: {},
});

const ROUTE_CONFIGS = {
  '/cashflow': { collapseSidebar: false },
};

export const RouteProvider = ({ children }) => {
  const location = useLocation();
  const [collapseSidebar, setCollapseSidebar] = useState(false);

  useEffect(() => {
    const matchedConfig = Object.keys(ROUTE_CONFIGS).find(path =>
      location.pathname.startsWith(path)
    );

    if (matchedConfig) {
      const config = ROUTE_CONFIGS[matchedConfig];
      setCollapseSidebar(config.collapseSidebar || false);
    } else {
      setCollapseSidebar(false);
    }
  }, [location.pathname]);

  return (
    <RouteContext.Provider value={{ collapseSidebar }}>
      {children}
    </RouteContext.Provider>
  );
};

RouteProvider.propTypes = {
  children: node.isRequired,
};

export const useRouteConfig = () => useContext(RouteContext);
